<template>
  <el-select 
    v-model="val" 
    class="ADeliveryWaySelector inline" 
    @change="change"
  >
    <el-option 
      v-for="item in items" 
      :key="item.value" 
      :label="item.label" 
      :value="item.value" 
    />
  </el-select>
</template>
<script>
import { selector } from "@/common/mixins/selector";

export default {
  name: "ADeliveryWaySelector",
  mixins: [selector],  
  computed: {
    items: function() {
      return this.system.options.delivery_way_flag;  
    }
  },
};
</script>
